import React from 'react';
import PropTypes from 'prop-types';

// helpers
import classnames from 'classnames';

// styles
import styles from '../PdpSharedDetails/PdpSharedDetail.scss';

function PdpRespDetail({ title, children, dataTn, delimiter, printHide }) {
    const contentClasses = classnames(styles.content, { [styles.detailBlock]: !delimiter });
    const wrapperClasses = classnames(styles.wrapper, { [styles.printHide]: printHide });
    if (title && children) {
        return (
            <li className={wrapperClasses}>
                <div className={styles.title}>{title}</div>
                <div className={contentClasses} data-tn={`pdp-spec-${dataTn}`}>
                    {children}
                </div>
            </li>
        );
    }
}

PdpRespDetail.propTypes = {
    delimiter: PropTypes.string,
    dataTn: PropTypes.string.isRequired,
    title: PropTypes.node.isRequired,
    children: PropTypes.node.isRequired,
    printHide: PropTypes.bool,
};

export { PdpRespDetail };
